import { render, staticRenderFns } from "./DataImportTemplates.vue?vue&type=template&id=6cfbd842"
import script from "./DataImportTemplates.vue?vue&type=script&lang=js"
export * from "./DataImportTemplates.vue?vue&type=script&lang=js"
import style0 from "./DataImportTemplates.vue?vue&type=style&index=0&id=6cfbd842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports